/* @flow */
import * as React from 'react';

const StayAtHome = props => (
  <svg
    width={116}
    height={93}
    viewBox="0 0 116 93"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M78.247,29.959 C87.587,39.059 96.668,44.596 105.491,46.571 C114.314,48.546 117.587,54.812 115.311,65.368 C113.137,71.058 110.79,73.903 108.27,73.903 C109.06,76.946 105.921,82.335 102.811,80.408 C79.819,71.253 67.355,68.772 61.54,67.408 C57.664,66.499 63.233,54.016 78.247,29.959 Z"
    />
    <rect stroke="none" strokeWidth={1} fill="#FFFFFF" x={42} y={81} width={7} height={11} />
    <rect stroke="none" strokeWidth={1} fill="#FFFFFF" x={10} y={81} width={5} height={11} />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      fillRule="nonzero"
      points="42.745 86.285 47.682 86.285 47.682 81.348 42.745 81.348"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      fillRule="nonzero"
      points="10.281 86.285 15.218 86.285 15.218 81.348 10.281 81.348"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      fillRule="nonzero"
      d="M81.556,32.487 C81.556,32.487 71.402,32.813 72.997,50.624 L71.134,49.893 C71.134,49.893 62.258,53.586 67.955,68.821 C67.955,68.821 65.938,68.457 61.301,70.107 C56.664,71.757 53.43,73.018 49.855,70.107 C46.28,67.197 45.35,62.033 45.1,57.825 C44.85,53.617 44.079,49.95 39.655,40.969 C35.232,31.987 35.596,25.539 40.938,25.539 C46.28,25.539 46.738,30.638 46.738,30.638 C46.738,30.638 51.849,37.906 52.803,39.148 C53.757,40.39 54.818,39.937 55.483,36.811 C56.148,33.686 57.728,28.264 57.281,24.109 C56.835,19.953 54.814,9.503 56.314,5.812 C57.814,2.12 60.721,0.44 63.578,2.009 C66.434,3.577 66.02,8.817 66.02,8.817 L69.831,19.596 C69.831,19.596 78.066,29.364 81.556,32.487"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      fillRule="nonzero"
      d="M107.32,75.344 C105.45,74.353 103.551,73.178 101.674,71.851 C96.423,68.135 94.787,65.554 90.774,61.563 C86.253,57.067 82.348,53.184 78.222,50.996 C77.277,50.495 76.304,50.098 75.329,49.816 C74.561,49.594 73.749,50.047 73.528,50.833 C73.307,51.618 73.756,52.437 74.53,52.661 C75.314,52.888 76.103,53.211 76.873,53.619 C80.617,55.604 84.379,59.345 88.735,63.676 C92.831,67.749 94.558,70.422 100.009,74.278 C101.986,75.676 103.992,76.918 105.971,77.967 C106.187,78.081 106.417,78.135 106.645,78.135 C107.17,78.135 107.678,77.846 107.937,77.341 C108.309,76.616 108.033,75.723 107.32,75.344"
    />
    <path
      fill="#FFFFFF"
      d="M56.464,72.567 L56.464,72.567 L1.5,72.567 L1.5,72.567 C1.5,77.417 5.431,81.348 10.281,81.348 L47.682,81.348 C52.532,81.348 56.464,77.417 56.464,72.567 Z"
    />
    <path d="M74.97,51.166 C60.385,46.62 53.756,40.391 53.756,40.391 L46.793,31.323 C46.793,31.323 46.795,26.349 42.362,25.605 C37.93,24.861 35.515,30.538 37.07,35.219 C38.625,39.9 45.112,50.057 45.058,55.608 C45.005,61.157 46.04,68.938 52.061,71.412 C58.082,73.885 61.287,67.4 71.213,69.067 C81.139,70.733 86.768,76.731 102.703,79.406" />
    <path d="M74.969,51.142 C75.792,51.431 76.65,51.8 77.548,52.269 C85.198,56.263 90.656,63.402 101.916,70.625 C103.789,71.826 105.741,72.975 107.783,74.042" />
    <path d="M109.111,47.988 C102.607,45.287 96.936,43.226 89.378,38.265 C74.833,28.718 69.831,19.596 69.831,19.596 L66.02,8.818 C66.02,8.818 67.561,4.089 63.577,2.009 C59.594,-0.071 55.538,4.579 55.567,9.511 C55.596,14.443 58.618,26.111 56.848,31.371 C55.852,34.33 54.966,38.067 55.263,41.52" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      fillRule="nonzero"
      points="8.464 72.567 28.874 72.567 28.874 47.94 8.464 47.94"
    />
    <polygon stroke="#3A427C" points="8.464 72.567 28.874 72.567 28.874 47.94 8.464 47.94" />
    <path stroke="#FFFFFF" strokeWidth={2} d="M16.15,48.911 L16.15,54.602" />
    <polygon points="8.464 72.567 28.874 72.567 28.874 47.94 8.464 47.94" />
    <path d="M28.874,65.542 C34.035,65.542 35.777,61.044 35.777,55.883 C35.777,50.721 34.035,50.108 28.874,50.108" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      fillRule="nonzero"
      d="M17.849,60.617 L14.452,60.617 C13.83,60.617 13.326,60.113 13.326,59.491 L13.326,56.276 C13.326,55.961 13.457,55.66 13.689,55.447 L15.388,53.884 C15.819,53.487 16.482,53.487 16.913,53.884 L18.611,55.447 C18.843,55.66 18.975,55.961 18.975,56.276 L18.975,59.491 C18.975,60.113 18.471,60.617 17.849,60.617"
    />
    <path d="M14.915,40.969 C14.915,38.657 16.915,38.657 16.915,36.344 C16.915,34.03 14.915,34.03 14.915,31.717 C14.915,29.403 16.915,29.403 16.915,27.089" />
    <path d="M21.868,40.969 C21.868,38.657 23.496,38.657 23.496,36.344 C23.496,34.03 21.868,34.03 21.868,31.717" />
    <path d="M63.583,35.31 C63.583,35.31 62.219,37.228 62.925,39.554 C63.498,41.442 65.393,41.824 65.393,41.824" />
    <path d="M10.281,81.348 L9.31,91.222" />
    <path d="M16.109,81.348 L15.138,91.222" />
    <path d="M47.682,81.348 L48.653,91.222" />
    <path d="M41.855,81.348 L42.825,91.222" />
  </svg>
);

export default StayAtHome;



// WEBPACK FOOTER //
// ./src/assets/images/icons/stay-at-home.js